import React from 'react';
import { Flex } from '@atlaskit/primitives/compiled';
import type { UIAnalyticsEvent as AnalyticsEvent } from '@atlaskit/analytics-next';
import type { IntlShape } from '@atlassian/jira-intl';
import type { User } from '@atlassian/jira-common-directory-v2/src/model/index.tsx';
import PopularityCell from '@atlassian/jira-common-directory-v2/src/components/popularity-cell/view.tsx';
import type { ReturnFocusTo } from '@atlassian/jira-software-modal-dialog/src/common/types.tsx';
import Actions from '../actions/view.tsx';

type Props = {
	isWritable: boolean;
	systemDashboard: boolean;
	defaultOpen: boolean;
	intl: IntlShape;
	showSpinner: boolean;
	loggedInUserAccountId: string;
	caption: string;
	owner: User | null;
	popularity: number;
	onCopy: () => void;
	onEdit: () => void;
	onChangeOwner: () => void;
	onDelete: () => void;
	onCopyDashboardClick: (arg1: AnalyticsEvent) => void;
	onEditDashboardClick: (arg1: AnalyticsEvent) => void;
	onChangeOwnerClick: (arg1: AnalyticsEvent) => void;
	onDeleteDashboardClick: (arg1: AnalyticsEvent) => void;
	setReturnFocusTo: (returnFocusTo: ReturnFocusTo | null) => void | Promise<void>;
};

export default function PopularityWithActions(props: Props): React.JSX.Element {
	const { popularity } = props;

	return (
		<Flex alignItems="center" justifyContent="space-between">
			<PopularityCell popularity={popularity} />
			<Actions {...props} />
		</Flex>
	);
}
